import { render, staticRenderFns } from "./editDistributionInfo.vue?vue&type=template&id=ed55e982&scoped=true&"
import script from "./editDistributionInfo.vue?vue&type=script&lang=ts&"
export * from "./editDistributionInfo.vue?vue&type=script&lang=ts&"
import style0 from "./editDistributionInfo.vue?vue&type=style&index=0&id=ed55e982&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed55e982",
  null
  
)

export default component.exports